<template>
  <div class="microbiology-main-view">
    <Microbiology />
  </div>
</template>

<script>
import Microbiology from './Microbiology.vue'

export default {
  name: 'MicrobiologyMainView',
  components: {
    Microbiology,
  },
}
</script>

<style lang="scss">
.microbiology-main-view {
  min-height: 100vh;

  .sort-icon {
    position: inherit !important;
    padding: 7px 0 !important;
  }
}
</style>
